import * as React from 'react';
import FiltersBar from '../FiltersBar';
import LoadMore from '../LoadMore';
import NoResults from '../NoResults';
import { FiltersProvider } from '../../contexts/filters';
import { PostsProvider } from '../../contexts/posts';
import SearchFilters from '../SearchFilters';
import PostsGrid from '../PostsGrid';
import Posts from '../Posts';
import Pagination from '../PaginationNumbers';
import { useSettingsContext } from '../../contexts/settings';
import ResultCount from '../ResultCount';

const SearchLayout = () => {
	const settings = useSettingsContext();

	return (
		<>
			<FiltersProvider>
				<div className="search-header" data-theme="light">
					<div className="container">
						<h1 className="search-header__title">{settings.searchTitle || 'Search'}</h1>
						{settings.searchDescription && (
							<p className="search-header__description">
								{settings.searchDescription}
							</p>
						)}

						<FiltersBar>
							<SearchFilters />
						</FiltersBar>
					</div>
				</div>
				<PostsProvider>
					<Posts>
						<ResultCount foundPosts={0} />
						<PostsGrid posts={[]} />
						{settings.paginationType === 'load_more' ? (
							<LoadMore page={0} maxNumPages={0} />
						) : (
							<Pagination page={0} maxNumPages={0} />
						)}
						<NoResults posts={[]} />
					</Posts>
				</PostsProvider>
			</FiltersProvider>
		</>
	);
};

SearchLayout.displayName = 'SearchLayout';

export default SearchLayout;
